import { Tooltip } from '@mui/material';
import React, { useState, ReactNode, FC } from 'react';

interface ClipboardCopyProps {
  textToCopy: string;
  children: ReactNode;
}

const CopyToClipboardWrapper: FC<ClipboardCopyProps> = ({
  textToCopy,
  children,
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500); // Reset copied state after 1.5 seconds
      })
      .catch((err) => console.error('Unable to copy text: ', err));
  };
  const toolTip = React.useMemo(() => {
    return isCopied ? 'Copied!' : 'Click to Copy';
  }, [isCopied]);

  return (
    <>
      <Tooltip title={toolTip} placement='top' arrow>
        <span onClick={handleCopyClick} style={{ cursor: 'pointer' }}>
          {children}
        </span>
      </Tooltip>
    </>
  );
};

export default CopyToClipboardWrapper;
